import React, { useState, useEffect } from "react";
import { HelpButtonExpanded } from "../common/HelpButtonExpanded";
import { VideoPopup } from "../common/VideoPopup";
export const ReadyToStart = () => {
	const [isShowingVideo, setIsShowingVideo] = useState(false);
	const [isWatched, setIsWatched] = useState();

	const handleWatched = () => {
		setIsWatched(true);
	};

	return (
		<div className="text-black text-sm lg:text-base">
			<h2 className={"text-2xl font-bold mb-2 text-center mt-4 pt-2"}>
				You're ready to start...
			</h2>
			<div className={"pt-2 sm:pt-8"}>
				<p className={"mb-6"}>
					Thank you for choosing to use Your Health Companion.
				</p>
				<p className={"mb-6"}>
					If you'd like to watch an introductory video please click on the
					following link:
				</p>
				<div className={"w-full mx-auto space-y-2 mb-6"}>
					<HelpButtonExpanded
						onClick={() => setIsShowingVideo(true)}
						linkColorOverride="text-app-midblue"
						text={"Your Health Companion Introduction Video"}
					/>
				</div>
				<p className={"mb-4"}>
					You'll now be taken to the <span className="uppercase">Start</span>{" "}
					screen which is where Your Health Companion will usually start for
					you. Don't forget, you now have an account, so you won't need to
					Register again.
				</p>
				<p className="mb-4">
					After you <span className="uppercase">Sign in</span> you will be taken
					to your <span className="uppercase">Home</span> screen which has three{" "}
					<span className="uppercase">To-do</span> areas:
				</p>
				<ol className={"list-decimal list-inside mb-4 font-bold"}>
					<li>
						Your <span className="uppercase">Setup</span>
					</li>
					<li>
						Your <span className="uppercase">Reports</span>
					</li>
					<li>
						Your <span className="uppercase">Resources</span>
					</li>
				</ol>
				<p>
					Please complete your <span className="uppercase">Setup</span>{" "}
					information and watch the help videos in the <i>Resources</i>.
				</p>
			</div>
			<VideoPopup
				show={isShowingVideo}
				onClose={() => setIsShowingVideo(false)}
				onWatched={handleWatched}
				title={"Your Health Companion Introduction"}
				videoUrl={"https://youtu.be/QMuwF8AFAm4"}
				registration={true}
			/>
		</div>
	);
};
